export function getOptionscmb(data) {
  // console.log("itemCtrl: --data***********- ", data)
  if (data.length > 0) {
    // console.log("itemCtrl: --data.questionDefinitions***********- ", data.QuestionDefinitions)
    return data.map((itemCtrl, index) => {
      // console.log("Items: ", itemCtrl)
      return {
        id: index,
        label: itemCtrl.Clave + ' - ' + itemCtrl.Estado,
        value: itemCtrl.Value,
        required: true
      }
    })
  } else {
    return []
  }
}

export function getFormatData(data) {
  if (data.length > 0) {
    return data.map((itemCtrl, index) => {
      console.log("---------getFormatData-------Items--------------: ", itemCtrl)
      return {
        id: index,
        Clave: itemCtrl.Clave + ' - ' + itemCtrl.Estado,
        Value: itemCtrl.Value,
        LimiteSuperior: itemCtrl.LimiteSuperior === undefined || itemCtrl.LimiteSuperior === null || itemCtrl.LimiteSuperior == "" ? 406000 : Number(itemCtrl.LimiteSuperior),
        LimiteInferior: itemCtrl.LimiteInferior === undefined || itemCtrl.LimiteInferior === null || itemCtrl.LimiteInferior == "" ? 1000 : Number(itemCtrl.LimiteInferior),
        PlazoNombre: itemCtrl.Plazos === undefined || itemCtrl.Plazos === null || itemCtrl.Plazos == "" ? "meses" : itemCtrl.Plazos.split(',')[0] == "Q" ? "quincenas" : "meses",
        PlazoNombreCalculate: itemCtrl.Plazos === undefined || itemCtrl.Plazos === null || itemCtrl.Plazos == "" ? "mensual" : itemCtrl.Plazos.split(',')[0] == "Q" ? "quincenal" : "mensual",
        PlazosList: getItemsPlazo(itemCtrl),
        Saltos: itemCtrl.Saltos === undefined || itemCtrl.Saltos === null || itemCtrl.Saltos == "" ? 1000 : Number(itemCtrl.Saltos),
        Estado: itemCtrl.Estado
      }
    })
  } else {
    return []
  }
}

export function getFormatCalculateData(data) {
  if (data != undefined && data != null) {
    return {
      LimiteSuperior: data.MaximumAmount,
      LimiteInferior: data.MinimumAmount,
      CapacidadPago: data.PaymentCapacity,
      Saltos: data.Step,
      PlazoNombre: data.TermType == "Q" ? "quincenas" : "meses",
      PlazoNombreCalculate: data.TermType == "Q" ? "quincenal" : "mensual",
      PlazosList: getItemsPlazoCalculate(data),
    }
  } else {
    return null
  }
}

function getItemsPlazo(data) {
  let tempType = data.Plazos.split(',')[0];
  if (data.Plazos === undefined || data.Plazos === null || data.Plazos == "") {
    return []
  } else {
    return data.Plazos.replace("Q,", "").replace("M,", "").replace("q,", "").replace("m,", "").split(',').map((itemCtrl, index) => {
      // console.log("Plazos itemCtrl. ", itemCtrl)
      return {
        id: index,
        label: `${itemCtrl} ${tempType == "Q" ? "quincenas" : "meses"}`,
        value: Number(itemCtrl),
        required: true
      }
    })
  }
}


function getItemsPlazoCalculate(data) {
  if (data.Terms === undefined || data.Terms === null || data.Terms == "") {
    return []
  } else {
    return data.Terms.map((itemCtrl, index) => {
      console.log("............Plazos itemCtrl.............: ", itemCtrl)
      return {
        id: index,
        label: `${itemCtrl} ${data.TermType == "Q" ? "quincenas" : "meses"}`,
        value: Number(itemCtrl),
        required: true
      }
    })
  }
}